(function () {
  var sectionId = document.currentScript?.dataset.sectionId;

  if (!sectionId) return;

  var swiperInstance = null;

  function initTrendingSwiper() {
    var swiperEl = document.getElementById('trending-swiper-' + sectionId);

    if (!swiperEl || typeof Swiper === 'undefined') return;

    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    var wrapper = swiperEl.closest('.trending__slider-wrapper');

    function toggleFades(sw) {
      wrapper.classList.toggle('is-beginning', sw.isBeginning);
      wrapper.classList.toggle('is-end', sw.isEnd);
    }

    swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 4,
      spaceBetween: 16,
      watchOverflow: true,
      navigation: {
        prevEl: '#trending-prev-' + sectionId,
        nextEl: '#trending-next-' + sectionId
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 12, centeredSlides: true },
        480: { slidesPerView: 2, spaceBetween: 14, centeredSlides: false },
        768: { slidesPerView: 3, spaceBetween: 16, centeredSlides: false },
        990: { slidesPerView: 4, spaceBetween: 16, centeredSlides: false }
      },
      on: {
        init: toggleFades,
        slideChange: toggleFades,
        resize: toggleFades
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrendingSwiper);
  } else {
    initTrendingSwiper();
  }
})();